import { render, staticRenderFns } from "./SidebarMinimizer.vue?vue&type=template&id=08ef3546&scoped=true"
import script from "./SidebarMinimizer.vue?vue&type=script&lang=js"
export * from "./SidebarMinimizer.vue?vue&type=script&lang=js"
import style0 from "./SidebarMinimizer.vue?vue&type=style&index=0&id=08ef3546&prod&scoped=true&lang=css"
import style1 from "./SidebarMinimizer.vue?vue&type=style&index=1&id=08ef3546&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef3546",
  null
  
)

export default component.exports